export enum ModuleTokens {
  Name = 'ticketsBase',
  Messages = 'ticketsMessagesBase'
}

// Topic IDs that should be always visible regardless of service status
export const ALWAYS_VISIBLE_TOPICS = ['GPU_SERVER_ISSUE'];
